var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterMediumLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5 12C24.5 18.6274 19.1274 24 12.5 24C5.87258 24 0.5 18.6274 0.5 12C0.5 5.37258 5.87258 0 12.5 0C19.1274 0 24.5 5.37258 24.5 12ZM8.52537 17.1799C11.3656 17.1799 13.668 14.8617 13.668 12.0021C13.668 9.14242 11.3656 6.82422 8.52542 6.82422C5.68522 6.82422 3.38281 9.14242 3.38281 12.0021C3.38281 14.8617 5.68522 17.1799 8.52537 17.1799ZM19.3096 12.003C19.3096 14.6949 18.1583 16.877 16.7383 16.877C15.3182 16.877 14.167 14.6949 14.167 12.003C14.167 9.31108 15.3182 7.12891 16.7383 7.12891C18.1583 7.12891 19.3096 9.31108 19.3096 12.003ZM20.7128 16.3707C21.2122 16.3707 21.6171 14.4155 21.6171 12.0037C21.6171 9.59188 21.2122 7.63672 20.7128 7.63672C20.2133 7.63672 19.8085 9.59188 19.8085 12.0037C19.8085 14.4155 20.2133 16.3707 20.7128 16.3707Z",
    fill: "#CBD1D6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterMediumLight);
export default __webpack_public_path__ + "static/media/FooterMediumLight.756e201ad9c4943a155f6e60ccd1a915.svg";
export { ForwardRef as ReactComponent };